import { Map } from 'immutable';

import * as types from './types';

const initialState = Map({
  loading: true,
  downloadLinks: {},
});

const tunnelsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.INITIALIZE.SUCCESS:
      return state.set('loading', false);
    case types.GET_SAUCE_CONNECT_DOWNLOAD_LINKS.SUCCESS:
      return state.set('downloadLinks', payload);
    default:
      return state || initialState;
  }
};

export default tunnelsReducer;
export { initialState };
